import { render } from "./FormulairesWizard.vue?vue&type=template&id=3e63e6fe&scoped=true"
import script from "./FormulairesWizard.vue?vue&type=script&lang=js"
export * from "./FormulairesWizard.vue?vue&type=script&lang=js"

import "./FormulairesWizard.vue?vue&type=style&index=0&id=3e63e6fe&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e63e6fe"]])

export default __exports__